import { isolatedCircuitId } from "./isolatedCircuitId";
import type { AreRouteLinesHidden } from "./types";

/**
 * Whether the plan leaves the cables off and draws the devices alone.
 *
 * *"Showing all routes at once is somehow lagging always."* 567 cables is 567
 * `non-scaling-stroke` paths carrying pointer events: re-rasterised on every
 * pan and hit-tested on every mouse move. So the switch is OFF by default, and
 * what it costs him is the cable BETWEEN the devices — never a device, never a
 * board, never a tray.
 *
 * **Isolating to one run beats the switch.** Narrowing the plan to one cable is
 * the more specific instruction and it is also cheap — one path, not 567 — so a
 * run he selects, hovers or is asked about is drawn whatever the switch says.
 * Without this, clicking a row with cables off showed him an empty plan and the
 * whole surface reads as broken.
 */
export const areRouteLinesHidden: AreRouteLinesHidden = ({
  areAllCablesShown,
  geometry,
  hoveredCircuitId,
  routeUnderReview,
  selectedCircuitId,
}) => {
  if (areAllCablesShown) return false;
  return !isolatedCircuitId({
    geometry,
    hoveredCircuitId,
    routeUnderReview,
    selectedCircuitId,
  });
};
